import { Controller } from "@hotwired/stimulus"

// UI-06: toggle the browser's own full-screen mode for the slideshow.
export default class extends Controller {
  toggle() {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      this.element.requestFullscreen?.()
    }
  }
}
